import { render, staticRenderFns } from "./CollectionOfUser.vue?vue&type=template&id=3a5a0c6c&scoped=true&"
import script from "./CollectionOfUser.vue?vue&type=script&lang=js&"
export * from "./CollectionOfUser.vue?vue&type=script&lang=js&"
import style0 from "./CollectionOfUser.vue?vue&type=style&index=0&id=3a5a0c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a0c6c",
  null
  
)

export default component.exports